export const bezahlungsartAuswahl = {
  fixgehalt: 'fixgehalt',
  stunden: 'stunden',
} as const;

export type BezahlungsartAuswahl = keyof typeof bezahlungsartAuswahl;
